import React, {useRef} from "react";
import {Formik, Field} from 'formik'
import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Textarea,
  VStack
} from "@chakra-ui/react";
import * as Yup from 'yup';
import FullScreenSection from "./FullScreenSection";
import useSubmit from "../hooks/useSubmit";
import {useAlertContext} from "../context/alertContext";
import emailjs from '@emailjs/browser';
import '../index.css'

const LandingSection = () => {
  const {response, submit} = useSubmit();
  const { onOpen } = useAlertContext();
  const form = useRef();

  const sendEmail = (e) => {
   // e.preventDefault();
    emailjs.sendForm('service_aqeb3n4', 'template_ovtaalk', form.current, '-XNbiAgv4STzNE7Vq')
      .then((result) => {
        console.log(result.text)
        onOpen(response);
      }, (error) => {
          alert("It's not you, it's us. Please wait a few moments and try again.", error);
      })
  }
  /*const handleSubmit = (e) =>{
    if(comment.values.length <= 25){
      e.preventDefault();
      e.stopPropagation();
      //isSubmitting(false)
    }else{
      sendEmail(e)
    }
    setValidated(true);
  }*/
  return (
    <FullScreenSection
      isDarkBackground
      backgroundColor="#512DA8"
      justifyContent="center"
      alignItems="center"
      p={12}
      w='100%'
    >
    <Box px={22} w='70%' alignItems="center" justifyContent="center" >
      <Formik
      initialValues= {{
        Name:'',
        email:'',
        comment:''
      }}
      onSubmit={(values, actions) => {
        submit(values)
        sendEmail(values)
        console.log(values)
        actions.resetForm();
        actions.setSubmitting(false)
    }}
      validationSchema={Yup.object({
        Name: Yup.string().min(2).required('Please enter your name'),
        email: Yup.string().email('Please enter a valid email').required('Please enter your email'),
        comment: Yup.string().required('Please enter your message').min( 25,'Minimum of 25 characters')
      })}
    >
      {({values, handleBlur, handleChange, handleSubmit, errors, touched}) => (
      <form className='bookingForm' ref={form} onSubmit={handleSubmit}>
        <VStack alignItems="flex-start" spacing={4}>
          <Heading as="h1" id="contactme-section" >
          Contact me
          </Heading>
              <FormControl isInvalid ={!!touched.Name && errors.Name}>
                <FormLabel htmlFor="Name">Name</FormLabel>
                <Field
                  as={Input}
                  id="Name"
                  name="Name"
                  placeholder="Type your name"
                  value={values.Name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                />
                <FormErrorMessage>{errors.Name}</FormErrorMessage>
              </FormControl>
              <FormControl isInvalid ={!!touched.email && errors.email} >
                <FormLabel htmlFor="email">Email Address</FormLabel>
                <Field
                  as={Input}
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Type your email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                />
                <FormErrorMessage>{errors.email}</FormErrorMessage>
              </FormControl>
              {/*<FormControl>
                <FormLabel htmlFor="type">Type of enquiry</FormLabel>
                <Select id="type" name="type" value={values.type} onChange={handleChange}>
                  <option value="hireMe">Freelance project proposal</option>
                  <option value="other">Other</option>
                </Select>
      </FormControl>*/}
              <FormControl isInvalid ={!!touched.comment && errors.comment}>
                <FormLabel htmlFor="comment">Your message</FormLabel>
                <Field
                  as={Textarea}
                  id="comment"
                  name="comment"
                  placeholder="Type your message"
                  type='text'
                  height={250}
                  value={values.comment}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                />
                <FormErrorMessage>{errors.comment}</FormErrorMessage>
              </FormControl>
              <Button className="button" type="submit" bg='indigo' transition= '2s' _hover={{bgGradient: 'linear(to-r, transparent, #4700D8, indigo )'}} width="full">
                Submit
              </Button>
        </VStack>
      </form>
      )}
      </Formik>
      </Box>
    </FullScreenSection>
  );
};

export default LandingSection;
